import { Point } from './editorTypes';
import { RGBColor } from 'react-color';

export type PageShapes = Record<number, Shape[]>;

export enum ShapeTypes {
  Ellipse = 'Ellipse',
  Line = 'Line',
  Rectangle = 'Rectangle',
  Arrow = 'Arrow',
}

export type BaseShape = {
  id: string;
  type: ShapeTypes;
  canvasPoints: Point[];
  pdfPoints: Point[];
  backgroundColor: RGBColor;
  borderWidth?: number;
  // In-memory only (never serialized): marks a rectangle created by the whiteout/erase
  // tool. Text boxes covered by such a rectangle are locked from editing (see
  // isTextItemWhitedOut). Plain shape-tool rectangles leave this unset and never lock text.
  isWhiteout?: boolean;
};

export type RectangleShape = BaseShape & {
  type: ShapeTypes.Rectangle;
  borderColor: RGBColor;
};

export type EllipseShape = BaseShape & {
  type: ShapeTypes.Ellipse;
  borderColor: RGBColor;
};

export type LineShape = BaseShape & {
  type: ShapeTypes.Line;
  borderColor: undefined;
};

export type ArrowShape = BaseShape & {
  type: ShapeTypes.Arrow;
  borderColor: undefined;
};

export type Shape = RectangleShape | LineShape | ArrowShape | EllipseShape;
